<template><top-nav /></template>
<script>
import TopNav from './TopNavBar';
export default { components: { TopNav } };
</script>
